/**
 * Enum of all entities
 */ export var EntityType = /*#__PURE__*/ function(EntityType) {
    EntityType["Plan"] = "Plan";
    EntityType["Bucket"] = "Bucket";
    EntityType["Task"] = "Task";
    EntityType["Goal"] = "Goal";
    EntityType["Sprint"] = "Sprint";
    EntityType["Calendar"] = "Calendar";
    EntityType["ChecklistItem"] = "ChecklistItem";
    EntityType["ContentLink"] = "ContentLink";
    EntityType["UserAssignment"] = "UserAssignment";
    EntityType["Dependency"] = "Dependency";
    EntityType["Portfolio"] = "Portfolio";
    EntityType["PlannerRoster"] = "PlannerRoster";
    EntityType["PlannerRosterMember"] = "PlannerRosterMember";
    EntityType["Template"] = "Template";
    EntityType["ChatMessage"] = "ChatMessage";
    EntityType["User"] = "User";
    EntityType["PlanSensitivityUserRights"] = "PlanSensitivityUserRights";
    EntityType["Publication"] = "Publication";
    EntityType["CustomFieldDefinition"] = "CustomFieldDefinition";
    EntityType["CustomView"] = "CustomView";
    EntityType["HistoryItem"] = "HistoryItem";
    return EntityType;
}({});
